import { contactInfoContent } from '../content/company-info.content';
import './ContactFab.css';

/**
 * Floating "تماس با ما" button, fixed to the bottom-left corner of the
 * viewport on every public page (rendered once in PageShell, not per-page).
 * Links to the real WhatsApp number already used on the Contact page and
 * Footer (company-info.content.ts) — no new contact detail invented here.
 */
export function ContactFab() {
  return (
    <a
      href={contactInfoContent.whatsappHref}
      target="_blank"
      rel="noreferrer"
      className="dma-contact-fab"
      aria-label="تماس با ما از طریق واتساپ"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.77.46 3.45 1.32 4.94L2 22l5.29-1.39a9.9 9.9 0 0 0 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm5.8 14.02c-.24.68-1.4 1.3-1.93 1.38-.49.08-1.11.11-1.79-.11-.41-.13-.94-.3-1.62-.6-2.85-1.23-4.71-4.1-4.85-4.29-.14-.19-1.16-1.54-1.16-2.94s.73-2.09.99-2.38c.26-.28.56-.35.75-.35h.53c.17 0 .4-.03.62.47.24.56.79 1.94.86 2.08.07.14.12.31.02.5-.09.19-.14.31-.28.48-.14.17-.29.37-.42.5-.14.14-.28.29-.12.57.16.28.72 1.19 1.55 1.93 1.06.95 1.96 1.24 2.24 1.38.28.14.44.12.6-.07.16-.19.68-.79.87-1.06.19-.28.37-.23.62-.14.26.09 1.63.77 1.91.91.28.14.47.21.53.33.07.12.07.68-.17 1.36Z" />
      </svg>
      <span>تماس با ما</span>
    </a>
  );
}
